import $ from 'jquery';

if ($('.accordion').length) {
  $('.accordion__header').on('click', (event) => {
    event.stopPropagation();
    setTimeout(() => {
      const $self = $(event.currentTarget);
      const $plus = $self.children('.icon-plus');
      const $minus = $self.children('.icon-minus');
      if ($self.hasClass('toggle__switch--on')) {
        $plus.hide();
        $minus.show();
      } else {
        $plus.show();
        $minus.hide();
      }
    }, 1);
  });
}
